var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62595 8L9.58015 13.5964C9.86005 13.8595 10 14.1943 10 14.6009C10 15.0075 9.86005 15.3423 9.58015 15.6054C9.30025 15.8685 8.94402 16 8.51145 16C8.07888 16 7.72265 15.8685 7.44275 15.6054L0.419847 9.00449C0.267176 8.86099 0.159033 8.70553 0.0954198 8.53812C0.0318066 8.3707 0 8.19133 0 8C0 7.80867 0.0318066 7.6293 0.0954198 7.46188C0.159033 7.29447 0.267176 7.13901 0.419847 6.99552L7.44275 0.394619C7.72265 0.13154 8.07888 0 8.51145 0C8.94402 0 9.30025 0.13154 9.58015 0.394619C9.86005 0.657698 10 0.992526 10 1.3991C10 1.80568 9.86005 2.14051 9.58015 2.40359L3.62595 8Z",
    fill: "#036BAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbtn);
export default __webpack_public_path__ + "static/media/backbtn.319f415172ef61a8fe70190c474d79ca.svg";
export { ForwardRef as ReactComponent };